'use client';

import Icon from '@/components/ui/AppIcon';

interface QuickAction {
  label: string;
  icon: string;
  onClick: () => void;
}

interface QuickActionsProps {
  actions: QuickAction[];
}

export default function QuickActions({ actions }: QuickActionsProps) {
  return (
    <div data-component-id="src/app/analytics-dashboard/components/QuickActions.tsx:17:4" data-component-path="src/app/analytics-dashboard/components/QuickActions.tsx" data-component-line="17" data-component-file="QuickActions.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-3%22%7D" className="flex flex-wrap gap-3">
      {actions.map((action, index) => (
        <button data-component-id="src/app/analytics-dashboard/components/QuickActions.tsx:19:8" data-component-path="src/app/analytics-dashboard/components/QuickActions.tsx" data-component-line="19" data-component-file="QuickActions.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22flex%20items-center%20gap-2%20px-4%20py-2%20bg-primary%20text-primary-foreground%20rounded-md%20hover%3Abg-primary%2F90%20transition-micro%20text-sm%20font-medium%22%7D"
          key={index}
          onClick={action.onClick}
          className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-micro text-sm font-medium"
        >
          <Icon data-component-id="src/app/analytics-dashboard/components/QuickActions.tsx:24:10" data-component-path="src/app/analytics-dashboard/components/QuickActions.tsx" data-component-line="24" data-component-file="QuickActions.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={action.icon as any} size={18} />
          <span data-component-id="src/app/analytics-dashboard/components/QuickActions.tsx:25:10" data-component-path="src/app/analytics-dashboard/components/QuickActions.tsx" data-component-line="25" data-component-file="QuickActions.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{action.label}</span>
        </button>
      ))}
    </div>
  );
}